<section class="container">
  <div class="reset">
    <div class="reset-body" *ngIf="isValidated == true">
      <div class="reset-title">
        {{ "change Password" | translate }}
      </div>
      <div class="reset-desc">
        {{ "Please choose a strong and memorable password" | translate }}
      </div>

      <form [formGroup]="changePasswordForm">
        <div class="webkit-center">
          <div class="form-group width-adjust">
            <app-evento-input
              [eventoFormControl]="changePasswordForm.get('password')!"
              type="password"
              requiredMessage="{{ 'Required Field' | translate }}"
              placeholder="{{ 'new password' | translate }}"
              minlengthMessage="{{
                'Min Length Field' | translate : { value: '6' }
              }}"
            ></app-evento-input>
          </div>
          <div class="form-group width-adjust">
            <app-evento-input
              [eventoFormControl]="changePasswordForm.get('confirmPassword')!"
              type="password"
              requiredMessage="{{ 'Required Field' | translate }}"
              mustMatchMessage="{{ 'Not Matched' | translate }}"
              placeholder="{{ 'Confirm the new password' | translate }}"
              minlengthMessage="{{
                'Min Length Field' | translate : { value: '6' }
              }}"
            ></app-evento-input>
          </div>
        </div>
      </form>

      <button
        type="button"
        (click)="changePassword()"
        [disabled]="changePasswordForm.invalid"
        class="btn width-adjust mb-3"
      >
        {{ "Save" | translate }}
      </button>
    </div>
    <ng-container *ngIf="isValidated == false">
      <div class="reset-body">
        <div class="reset-title">
          {{ "error occured" | translate }}
        </div>
        <button
          type="button"
          (click)="navigateToHomeAndOpenLoginModal()"
          class="btn width-adjust mb-3"
        >
          {{ "try again" | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</section>
